import { WireHintComponent } from "common/wire";
import { WireRenderer } from "webapp/wire-renderers/wire-renderer";
import { defined } from "@glideapps/ts-necessities";
import "twin.macro";
import React from "react";
import { WireButton } from "../wire-button/wire-button";
import { Appearance } from "common/generator/components/button-appearance";

export const Hint: WireRenderer<WireHintComponent> = props => {
    return (
        <div
            tw="text-base text-text-dark px-8 py-5 min-height[80px] bg-g100 border border-solid border-g300 flex
                flex-col rounded-lg whitespace-pre-wrap
                gp-md:(flex-row items-center)">
            <div tw="flex-1">{props.description}</div>
            {props.action !== undefined && (
                <WireButton
                    appearance={Appearance.Bordered}
                    onClick={() => props.backend.runAction(defined(props.action).token, false)}>
                    {props.actionTitle}
                </WireButton>
            )}
        </div>
    );
};
